module.exports = __webpack_public_path__ + "static/mentor-anjuman-arora-3a4926412b724cdae0e566f22725e2e6.jpeg";